import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";

export const useGetRolesQuery = (id?: string) => {
  const token = localStorage.getItem("BETTY_ADMIN_USER_TOKEN");

  return useQuery({
    queryKey: ["useGetRolesQuery", id],
    queryFn: () =>
      axiosInstance
        .get(id ? `/admins/roles/${id}` : "/admins/roles", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => res.data),

    enabled: !!token,
  });
};
